import { useContext, useEffect } from "react";
import { useNewEditSupplyRoutes } from "../../../../../hooks";
import { ConfigContext } from "../../../../../utils/ConfigContext";
import { EditorContext } from "../../EditorContextProvider";
import { EditType } from "../../EditorSwiper/EditorSwiper";

const CurvedPolyline = ({ handleNext, isLastStep, disabled }) => {
  const { config } = useContext(ConfigContext);
  const {
    highlightFeature,
    setHighlightFeature,
    editableLayer,
    highlightHandle,
    editType,
    addedPoints,
    setAddedPoints,
  } = useContext(EditorContext);
  const getEditFeature = () => {
    if (editType === EditType.edit) {
      if (addedPoints.length > 0) {
        highlightFeature.geometry = addedPoints[0];
      }

      return highlightFeature;
    } else if (isLastStep && addedPoints.length > 0) {
      return {
        geometry: addedPoints[0],
        attributes: {},
      };
    }

    return null;
  };

  const { activateDraw, deactivateDraw } = useNewEditSupplyRoutes(
    editableLayer,
    config,
    getEditFeature(),
    highlightHandle,
    editType,
    disabled,
    (geometry, symbol) => {
      setAddedPoints([geometry]);

      // setHighlightFeature({ geometry, symbol, attributes: {} });
      if (handleNext) {
        handleNext();
      }
    }
  );

  useEffect(() => {
    if (editType === EditType.create && !isLastStep) {
      activateDraw();
    }

    return () => {
      deactivateDraw();
    };
  }, []);

  return <div />;
};

export default CurvedPolyline;
